import * as TypeGraphQL from "type-graphql";
export var SubscriptionPlan;
(function (SubscriptionPlan) {
    SubscriptionPlan["FREE"] = "FREE";
    SubscriptionPlan["PRO"] = "PRO";
    SubscriptionPlan["INSTITUTION"] = "INSTITUTION";
})(SubscriptionPlan || (SubscriptionPlan = {}));
TypeGraphQL.registerEnumType(SubscriptionPlan, {
    name: "SubscriptionPlan",
    description: undefined,
});
//# sourceMappingURL=SubscriptionPlan.js.map